<template>
  <div class="pVodWrap modal qna" :class="{ open: timeFlag }">
    <div class="pVodBar">
      <p>{{ $t('mypage.doProductQuestion') }}</p>
      <button @click="modalClosed" class="close" v-if="exit"></button>
    </div>
    <div class="pVodQna">
      <div class="selectBtn" v-if="clickSelectList">
        <button @click="listShow">
          {{ $t('mypage.findProduct') }}
        </button>
      </div>
      <div class="selectBox">
        <ul class="selectBoxUl" v-if="selectListFlag">
          <li
            class="selectBoxLi"
            v-for="list in productList"
            v-bind:key="list.broadcastProductSysId"
            @click="seletedPrdt(list)"
          >
            <div class="prdtListImg">
              <img :src="list.squareImageUrl || list.bigImageUrl" />
            </div>
            <div class="prdtListInfo">
              <p class="prdtInfoTitle">{{ list.name }}</p>
              <p class="prdtInfoBrand">{{ list.brandName }}</p>
              <div class="prdtInfoPrice">
                <p
                  class="prdtDisCount"
                  v-if="ProductService.prdtPrice(list).discountRate > 0"
                >
                  {{ ProductService.prdtPrice(list).discountRate }}%
                </p>
                <p class="prdtPrice">
                  {{ ProductService.prdtPrice(list).value | makeComma }}원
                </p>
                <p
                  class="prdtMarketMoney"
                  v-if="ProductService.prdtPrice(list).discountRate > 0"
                >
                  {{ list.marketPrice | makeComma }}
                </p>
              </div>

              <div class="labelBox">
                <span
                  v-if="ProductService.prdtPrice(list).isLiveCheck"
                  class="liveBenefit"
                  >{{ $t('product.liveBenefit') }}</span
                >
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="seletedPrdt" v-if="selectedPrdtFlag">
        <div class="seletedPrdtImg">
          <img :src="selectedPrdt.squareImageUrl || selectedPrdt.bigImageUrl" />
        </div>
        <div class="seletedPrdtInfo">
          <p class="seletedPrdtSpan">{{ $t('mypage.inquiryProduct') }}</p>
          <p class="seletedPrdtTitle">{{ selectedPrdt.name }}</p>
          <button class="selectdPrdtClose" @click="selectX"></button>
        </div>
      </div>
      <div class="pVodQnaText">
        <textarea
          :placeholder="$t('customer.insertInquiryInfo')"
          v-model="qnaContents"
          @keydown="rowsChk"
          @focus="closeSelectBox"
        />
      </div>
      <!-- <div class="pVodQnaBtn" :class="{'on' : !qnaValid}">
        <button @click="QnABtn" :disabled="qnaValid">문의하기</button> -->
      <div
        class="pVodQnaBtn"
        :class="{
          on: this.qnaContents !== '' && this.selectedPrdtFlag === true
        }"
      >
        <button @click="QnABtn">{{ $t('mypage.doQuestion') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { postPrdtQuestion } from '@/api/index.js'

export default {
  props: ['exit', 'productList', 'showQnaModal', 'ProductService'],
  components: {},
  data() {
    return {
      list: [],
      selectedPrdt: {},
      selectListFlag: false,
      selectedPrdtFlag: false,
      qnaContents: '',
      typeCode: 0,
      clickSelectList: true,
      timeFlag: false
    }
  },
  computed: {
    qnaValid() {
      if (
        this.qnaContents === '' ||
        this.qnaContents.replace(/ /g, '').length < 1
      ) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    closeSelectBox() {
      if (!this.selectedPrdtFlag) {
        this.selectListFlag = false
        this.clickSelectList = true
      }
    },
    modalClosed() {
      this.timeFlag = false
      setTimeout(() => {
        this.$emit('closeModal', false)
      }, 500)
    },
    listShow() {
      this.selectListFlag = !this.selectListFlag
      this.clickSelectList = false
    },
    seletedPrdt(list) {
      this.selectListFlag = false
      this.selectedPrdtFlag = true
      this.selectedPrdt = list
    },
    async QnABtn() {
      if (await window.isDemo()) {
        return false
      }
      
      let info = {
        questionTypeCode: this.typeCode,
        content: this.qnaContents
      }
      if (this.selectedPrdt.prdtSysId && this.qnaContents !== '') {
        postPrdtQuestion(
          sessionStorage.getItem('accessToken'),
          this.selectedPrdt.prdtSysId,
          info
        )
          .then((res) => {
            console.log(res)
            if (res.data.jsonData.resultCode === '0001') {
              alert(this.$t('customer.inquiryFin'))
              this.modalClosed()
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        alert(this.$t('customer.inserInquiryProductContent'))
        return false
      }
    },
    rowsChk() {
      let lineCnt = (this.qnaContents.match(/\n/g) || []).length
      console.log(lineCnt)
      if (lineCnt > 7) {
        return false
      }
    },
    selectX() {
      this.selectedPrdtFlag = false
      this.clickSelectList = true
      this.selectedPrdt = {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.timeFlag = this.showQnaModal
    })
  },
  watch: {
    productList: {
      handler(ol, nl) {
        if (ol !== nl) {
          this.modalClosed()
        }
      }
    },

    showQnaModal: {
      handler() {
        this.timeFlag = this.showQnaModal
      }
    }
  }
}
</script>
<style lang="scss">
.pVodWrap.modal {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 130;
  text-align: center;
  background-color: #fff;
  transition: all ease-in-out 0.3s;
  box-shadow: 0 3px 5px 1px rgb(0, 0, 0, 0.2);
  overflow-y: initial;
}
.pVodWrap.modal.qna {
  height: auto;
}

.pVodWrap.modal.focus {
  transform: translateY(-70%);
}

.pVodWrap.modal.qna .pVodBar {
  overflow: hidden;
  padding: 10px 15px;
  box-sizing: border-box;
}
.pVodWrap.modal.qna .pVodBar p {
  float: left;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 36px;
  letter-spacing: -0.5px;
  text-align: left;
  color: #141414;
}

.pVodWrap.modal .pVodBar button {
  /* position: absolute; */
  float: right;
  top: 12px;
  right: 10px;
  /* display: inline-block; */
  width: 36px;
  height: 36px;
  object-fit: contain;
  background: url('../../assets/img/ico/btn_livelist_close@3x.png') 0 0 / 100%
    auto no-repeat;
}

.pVodWrap.modal.qna .pVodBar p,
.pVodWrap.modal.qna .pVodBar button {
  position: static;
}

.pVodWrap.modal .pVodQna {
  margin: 5px;
  padding-bottom: 10px;
  text-align: center;
  height: 80%;
  overflow-y: auto;
}

.pVodWrap.modal .pVodQna .selectBtn {
  width: 90%;
  overflow: hidden;
  box-sizing: border-box;
  margin: 0px auto;
  height: 40px;
  border-radius: 2px;
  border: solid 1px #111111;
}
.pVodWrap.modal .pVodQna .selectBtn button {
  width: 100%;
  height: 40px;
  text-align: center;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #111111;
}

.selectBox {
  overflow-y: initial;
}

.selectBoxUl {
  width: 100%;
  /* border: 1px solid #ddd; */
  overflow: hidden;
  box-sizing: border-box;
  margin: 0px auto;
  height: 285px;
  overflow-y: auto;
}

.selectBoxUl .selectBoxLi {
  height: 90px;
  width: 100%;
  position: relative;
  display: inline-block;
  /* border-bottom: 1px solid #eeeeee; */
}
.selectBoxUl .selectBoxLi .prdtListImg {
  float: left;
  padding: 10px;
  box-sizing: border-box;
  margin-top: 5px;
}

.selectBoxUl .selectBoxLi .prdtListImg img {
  width: 80px;
  height: 80px;
}
.selectBoxUl .selectBoxLi .prdtListInfo {
  float: left;
  top: 10px;
  left: 100px;
  text-align: left;
  padding: 5px;
  margin-top: 5px;
  box-sizing: border-box;
  width: calc(100% - 100px);
}

.selectBoxUl .selectBoxLi .prdtListInfo .prdtInfoTitle {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #111111;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.selectBoxUl .selectBoxLi .prdtListInfo .prdtInfoBrand {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.5px;
  text-align: left;
  color: #aaaaaa;
}
.selectBoxUl .selectBoxLi .prdtListInfo .prdtInfoPrice {
  display: inline;
}
.prdtListInfo .prdtInfoPrice .prdtDisCount {
  display: inline;
  padding-right: 5px;
  color: $main-color;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: -0.47px;
  text-align: right;
}
.prdtListInfo .prdtInfoPrice .prdtPrice {
  display: inline;
  padding-right: 5px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: -0.47px;
  text-align: right;
  color: #141414;
}
.prdtListInfo .prdtInfoPrice .prdtMarketMoney {
  display: inline;
  text-decoration-line: line-through;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: -0.58px;
  text-align: right;
  color: #aaaaaa;
}
.prdtListInfo .labelBox span {
  display: inline-block;
  margin: 4px;
  padding: 1px 3px;
  border: 1px solid #767676;
  border-radius: 4px;
  font-size: 12px;
  color: #767676;
}
.prdtListInfo .labelBox span:first-child {
  margin-left: 0;
}
.prdtListInfo .labelBox .liveBenefit {
  color: #e73656;
  border: 1px solid #e73656;
}

.pVodWrap.modal .pVodQna .pVodQnaText {
  margin: 0 auto;
  width: 95%;
}

.pVodWrap.modal .pVodQna .pVodQnaText textarea {
  width: 100%;
  height: 150px;
  margin-top: 10px;
  border: 1px solid #eee;
  border-radius: 2px;
  padding: 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  resize: none;
}

.pVodWrap.modal .pVodQna .pVodQnaBtn {
  margin-top: 20px;
  width: 100%;
}

.pVodWrap.modal .pVodQna .pVodQnaBtn button {
  width: 90%;
  height: 50px;
  background-color: #f3f3f3;
  color: #999999;
}

.pVodWrap.modal .pVodQna .pVodQnaBtn.on button {
  width: 90%;
  height: 50px;
  background-color: #000000;
  color: #fff;
}
.pVodWrap.modal .pVodQna .seletedPrdt {
  width: 95%;
  margin-top: 5px;
  display: inline-block;
}

.pVodWrap.modal .pVodQna .seletedPrdt .seletedPrdtImg {
  float: left;
  box-sizing: border-box;
  margin-top: 5px;
}

.pVodWrap.modal .pVodQna .seletedPrdt img {
  width: 56px;
  height: 56px;
}

.pVodWrap.modal .pVodQna .seletedPrdt .seletedPrdtInfo {
  float: left;
  position: relative;
  text-align: left;
  padding: 5px;
  padding-right: 34px;
  margin-top: 5px;
  box-sizing: border-box;
  width: calc(100% - 59px);
  height: 56px;
  background-color: #f6f6f6;
}

.seletedPrdt .seletedPrdtInfo .seletedPrdtSpan {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.75;
  letter-spacing: -0.48px;
  text-align: left;
  color: #767676;
  margin-left: 5px;
}

.seletedPrdt .seletedPrdtInfo .seletedPrdtTitle {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.56px;
  text-align: left;
  color: #191919;
  margin-left: 5px;
}

.seletedPrdt .seletedPrdtInfo .selectdPrdtClose {
  position: absolute;
  right: 15px;
  top: 20px;
  width: 10.6px;
  height: 10.6px;
  object-fit: contain;
  background-color: #979797;
  background: url('../../assets/img/ico/close_sm_df@3x.png') 0 0 / 100% auto
    no-repeat;
}
</style>